<ng-container>
    <button *ngIf="buttonVisibility()" mat-mini-fab color="primary" class="positionAbsoliteRight0" aria-label="edit RC" (click)="openEditFieldsModal()" [disabled]="setDisabled()">
        <mat-icon>edit</mat-icon>
    </button>
</ng-container>